import React from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { CollectionType, EntityType } from "../../../../common/enum";
import {
  getMyCollection,
  getMyDonationCollection,
} from "../../../CreateCollection/slice";
import { db } from "../../../../firebase";
import {
  collectionGroup,
  getDocs,
  where,
  collection as firebaseCollection,
  query,
  getCountFromServer,
} from "firebase/firestore";
import { setSelectCollectionDate } from "../../slice";

export const useCollection = () => {
  const {
    auth,
    collection,
    dashboardInfo: { selectCollectionDate, entityProfileSelect },
  } = useSelector((state) => state);
  const [monthStartDate, setMonthStartDate] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [key, setKey] = React.useState(Math.random());
  // moment().startOf("month").format("YYYY-MM-DD")
  const [monthEndDate, setMonthEndDate] = React.useState(null);
  // moment().endOf("month").format("YYYY-MM-DD")
  const [dateState, setDateState] = React.useState(new Date());
  const dispatch = useDispatch();
  const [particularDateCollection, setParticularDateCollection] =
    React.useState([]);
  const { myCollections, myDonationCollections } = collection;
  const { userId } = auth.user;
  const {
    entity: { entityType },
  } = auth.profile;

  React.useEffect(() => {
    if (selectCollectionDate !== null) {
      setDateState(selectCollectionDate);
      const firstDate = new Date(
        selectCollectionDate.getFullYear(),
        selectCollectionDate.getMonth(),
        1
      );
      const lastDate = new Date(
        selectCollectionDate.getFullYear(),
        selectCollectionDate.getMonth() + 1,
        1
      );
      setMonthStartDate(moment(firstDate).format("YYYY-MM-DD"));
      setMonthEndDate(moment(lastDate).format("YYYY-MM-DD"));
      dispatch(setSelectCollectionDate(null));
    }
  }, [selectCollectionDate,dispatch]);
  React.useEffect(() => {
    if (monthStartDate !== null && monthEndDate !== null) {
      let payload = {
        // offset: 0,
        // limit: 100,
        donorId: "",
        startDate: monthStartDate,
        endDate: monthEndDate,
      };
      if (
        entityType === EntityType.distributor ||
        entityType == 'SPECIAL_DISTRIBUTOR' ||
        (entityType === EntityType.donorDistributor &&
          entityProfileSelect === EntityType.distributor)
      ) {
        payload["collectorId"] = userId;
        dispatch(getMyCollection(payload));
      } else if (
        entityType === EntityType.donor ||
        (entityType === EntityType.donorDistributor &&
          entityProfileSelect === EntityType.donor)
      ) {
        payload["donorId"] = userId;
        dispatch(getMyDonationCollection(payload));
      }
    }
  }, [dispatch, entityProfileSelect, monthStartDate, monthEndDate, key]);

  const allCollectionDetail = React.useMemo(() => {
    let donatedCollection = [];
    let myCollection = [];
    if (myDonationCollections?.collectionDetails !== undefined) {
      donatedCollection = myDonationCollections.collectionDetails.map(
        (item) => {
          const { collection } = item;
          const obj = Object.assign({}, collection, {
            ...collection,
            collectionType: CollectionType.DONATED,
          });
          return { ...item, obj };
        }
      );
    }

    if (myCollections?.collectionDetails !== undefined) {
      myCollection = myCollections.collectionDetails.map((item) => {
        const { colllection } = item;
        const obj = Object.assign({}, colllection, {
          collectionType: CollectionType.COLLECTION,
        });

        return { ...item, obj };
      });
    }

    return entityType === EntityType.donor ||
      (entityType === EntityType.donorDistributor &&
        entityProfileSelect === EntityType.donor)
      ? donatedCollection
      : myCollection;
  }, [myCollections, myDonationCollections]);

  const collectionDate = React.useMemo(() => {
    if (allCollectionDetail !== undefined) {
      return allCollectionDetail.map(
        (item) => item.collection.dateOfCollection
      );
    } else {
      return [];
    }
  }, [allCollectionDetail]);

  const getMessageCount = async (id) => {
    try {
      // const q = query(
      //   collectionGroup(db, "messages"),
      //   where("isRead", "==", false),
      //   where("senderId", "!=", userId),
      //   where("collectionId", "==", id)
      // );
      const q =query(collectionGroup(db,"messages"))
      where("isRead", "==", false),
      where("senderId", "!=", userId),
      where("collectionId", "==", id)
      const qu = query(
        collectionGroup(db, "messages"),
        // where("senderId", "==", userId),
        where("collectionId", "==", id)
      );
      const resCount = await getCountFromServer(qu);
      const res = await getCountFromServer(q);
      return { unReadcount: res.data().count, count: resCount.data().count };
    } catch (err) {
     // console.log("aqui --->", err.message);
    }
  };

  const allCollection = React.useCallback(async () => {
    if (allCollectionDetail.length > 0) {
      const data = allCollectionDetail.filter((item) => {
        if (
          dateState !== null &&
          new Date(item.collection.dateOfCollection).toDateString(
            "pt"
          ) === dateState.toDateString()
        ) {
          return item;
        }
      });
      const updateData = await Promise.all(
        data.map(async (value) => {
          value["messageCount"] = await getMessageCount(value.collection.id);
          return value;
        })
      );
      setParticularDateCollection(
        updateData.sort(
          (a, b) =>
            new Date(a.collection.dateOfCollection) -
            new Date(b.collection.dateOfCollection)
        )
      );
      setLoading(false);
    } else {
      setLoading(false);
      return [];
    }
  }, [allCollectionDetail, dateState]);

  React.useEffect(() => {
    setLoading(true);
    allCollection();
  }, [allCollectionDetail, dateState]);

  return {
    loading,
    allCollectionDetail,
    collectionDate,
    setMonthStartDate,
    setMonthEndDate,
    dateState,
    setDateState,
    setKey,
    particularDateCollection,
  };
};
